














export default {
  props: {
    sunken: Boolean,
  },
};
